<template>
  <div class="wrap display-flex">
       <div class="logo">
          <img src="../assets/Spryntr-logo.svg" alt="">
      </div>

    <nav>
          <ul>
            <li>
                  <router-link to='/'>faq</router-link>
            </li>
            <li>
                  <router-link to="/">privacy</router-link>
            </li>
            <li>
                  <router-link to="/">Terms & conditions</router-link>
            </li>
            <li>
                <router-link to="/">Contact</router-link>
            </li>
        </ul>
    </nav>

      <div class="buttons display-flex">
          <div class="individual_button">
                <img src="../assets/Twitter.svg" alt="">
          </div>
          <div class="individual_button">
               <img src="../assets/google.svg" alt="">
          </div>
         <div class="individual_button">
               <img src="../assets/facebook.svg" alt="">
          </div>
      </div>
  </div>
</template>

<script>
export default {
name: 'Footer'
}
</script>

<style lang="scss" scoped>
.wrap{
     width: 85%;
     padding:50px 0px;
     margin:0 auto;
     color:white;
  nav{
          width:45%;
      ul{
            display: flex;
            align-items: center;
            justify-content: space-between;
          li{
                font-family: 'DM Sans', sans-serif;
                cursor: pointer;
                list-style-type: none;
                text-transform: uppercase;
                font-size: 0.9em;
                font-weight: 400;
             a{
               text-decoration: none;
               color: #ffffff;
               }
            }
        }
    }
    .buttons{
        width:12%;
    }
}
@media (max-width:957px){
  .wrap{
    width: 92%;
    nav{
      width:50%;
    }
  }
}
@media (max-width:830px){
   .wrap{
      flex-direction: column;
      align-items: flex-start;
      .logo{
        order:1;
      }
    nav{
      order: 3;
      width: 100%;
      margin-top: 30px;
      ul{
        flex-direction: column;
        align-items:flex-start;
        li{
          margin:5px 0px;
        }
      }
    }
    .buttons{
      width: 30%;
      margin-top: 30px;
      flex-direction: row;
      order:2;
    }
  }

  @media (max-width:450px){
    .wrap{
      .buttons{
        width:50%;
      }
    }
  }
}
</style>